import { Component, inject } from '@angular/core';
import { NPSAreas } from '@empathy/survey/base';

import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';

@Component({
  selector: 'empathy-conditional-nps-score-form',
  templateUrl: './conditional-nps-score-form.component.html',
  styleUrls: ['./conditional-nps-score-form.component.scss']
})
export class ConditionalNpsScoreFormComponent {
  npsAreas = NPSAreas;

  surveyConditionalsService = inject(SurveyConditionalsService);
}
